import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { useState } from "react";


import PublishBimClassRevision from "./PublishBimClassRevision.graphql";
import UnpublishBimClassRevision from "./UnpublishBimClassRevision.graphql";
import * as UI from "../../../../../../modules/ui-kit";

export default function Publishing(props) {
    const { id, public: isPublic, revisionID } = props;
    const [busy, setBusy] = useState(false);

    const [publishBimClassRevision] = useMutation(
        gql(PublishBimClassRevision),
        {
            // Publishing moves the "public" tag off whichever revision held it,
            // so the whole version list is stale, not just this revision.
            awaitRefetchQueries: true,
            refetchQueries: [
                "ReadBimClass",
                "ListBimClassRevisions",
                "ListBimClasses",
            ],
            variables: {
                id,
                revisionID,
            },
        },
    );
    const [unpublishBimClassRevision] = useMutation(
        gql(UnpublishBimClassRevision),
        {
            // The "public" tag moves off whichever revision held it, so the
            // version list is stale too — refetching only the revision on
            // screen left the previous one badged "public" until a reload.
            awaitRefetchQueries: true,
            refetchQueries: [
                "ReadBimClass",
                "ListBimClassRevisions",
                "ListBimClasses",
            ],
            variables: {
                id,
                revisionID,
            },
        },
    );

    async function toggle() {
        setBusy(true);
        try {
            if (isPublic) {
                await unpublishBimClassRevision();
            } else {
                await publishBimClassRevision();
            }
        } finally {
            setBusy(false);
        }
    }

    return (
        <UI.Button
            $appearance={ isPublic ? "danger" : "primary" }
            $size="small"
            disabled={ busy }
            onClick={ toggle }
        >
            { busy ? (isPublic ? "Unpublishing…" : "Publishing…") : (isPublic ? "Unpublish" : "Publish") }
        </UI.Button>
    );
}
